/** Public support inbox shown on the site (mailto / legal). */
export const SUPPORT_EMAIL = 'support@talohub.store';
